import { produce } from 'immer';
import * as actions from '../constants/action-types';

export default (state = {}, { type, payload }) =>
    produce(state, (draft) => {
        switch (type) {
            case actions.LOADING_SETTINGS:
                draft.loading = payload.loading;

                break;

            case actions.RECEIVED_SETTINGS:
                return {
                    ...draft,
                    ...payload,
                };

            case actions.UPDATE_SETTINGS:
                draft.updating = payload.updating;

                break;

            case actions.GET_TAGS_LIST:
                draft.tagsLoading = true;
                break;

            case actions.RECEIVED_TAGS_LIST:
                draft.tagsLoading = false;
                draft.tags = payload.tags;
                break;

            case actions.GET_TAGS_LIST_ERROR:
                draft.tagsLoading = false;
                draft.tagsError = true;
                break;

            // Two-Factor Authentication (2FA)
            case actions.TWO_FACTOR_SETUP_REQUEST:
                draft.twoFactor = {
                    ...draft.twoFactor,
                    isSettingUp: true,
                    setupError: null,
                };
                break;

            case actions.TWO_FACTOR_SETUP_SUCCESS:
                draft.twoFactor = {
                    ...draft.twoFactor,
                    isSettingUp: false,
                    secret: payload.secret,
                    qrUrl: payload.qrUrl,
                    otpauthUri: payload.otpauthUri,
                    setupError: null,
                };
                break;

            case actions.TWO_FACTOR_SETUP_ERROR:
                draft.twoFactor = {
                    ...draft.twoFactor,
                    isSettingUp: false,
                    setupError: payload.errorMessage,
                };
                break;

            case actions.TWO_FACTOR_ENABLE_REQUEST:
                draft.twoFactor = {
                    ...draft.twoFactor,
                    isEnabling: true,
                    enableError: null,
                };
                break;

            case actions.TWO_FACTOR_ENABLE_SUCCESS:
                draft.twoFactor = {
                    ...draft.twoFactor,
                    isEnabling: false,
                    enableError: null,
                    secret: null,
                    qrUrl: null,
                    otpauthUri: null,
                };
                draft.totp_enabled = payload.totpEnabled;
                break;

            case actions.TWO_FACTOR_ENABLE_ERROR:
                draft.twoFactor = {
                    ...draft.twoFactor,
                    isEnabling: false,
                    enableError: payload.errorMessage,
                };
                break;

            case actions.TWO_FACTOR_DISABLE_REQUEST:
                draft.twoFactor = {
                    ...draft.twoFactor,
                    isDisabling: true,
                    disableError: null,
                };
                break;

            case actions.TWO_FACTOR_DISABLE_SUCCESS:
                draft.twoFactor = {
                    ...draft.twoFactor,
                    isDisabling: false,
                    disableError: null,
                };
                draft.totp_enabled = payload.totpEnabled;
                break;

            case actions.TWO_FACTOR_DISABLE_ERROR:
                draft.twoFactor = {
                    ...draft.twoFactor,
                    isDisabling: false,
                    disableError: payload.errorMessage,
                };
                break;

            case actions.TWO_FACTOR_CLEAR_SETUP:
                draft.twoFactor = {
                    isSettingUp: false,
                    isEnabling: false,
                    isDisabling: false,
                    secret: null,
                    qrUrl: null,
                    otpauthUri: null,
                    setupError: null,
                    enableError: null,
                    disableError: null,
                };
                break;
        }
    });
